import type { Nullable } from '@/types'

type MessengerApiPreviewableAttachmentMetadata = {
  width: number
  height: number
  preview: {
    width: number
    height: number
  }
}

type MessengerApiAttachmentImageMetadata = MessengerApiPreviewableAttachmentMetadata & {
  type: 'image'
}

type MessengerApiAttachmentVideoMetadata = MessengerApiPreviewableAttachmentMetadata & {
  type: 'video'
}

export type MessengerApiAttachmentMetadata = MessengerApiAttachmentImageMetadata | MessengerApiAttachmentVideoMetadata

export type MessengerApiAttachment = {
  id: string
  name: string
  originalName: string
  mimeType: string
  size: number
  url: string
  previewUrl: Nullable<string>
  metadata: Nullable<MessengerApiAttachmentMetadata>
}

export const isMessengerApiAttachmentImageMetadata = (
  metadata?: MessengerApiAttachmentMetadata,
): metadata is MessengerApiAttachmentImageMetadata => metadata?.type === 'image'

export const isMessengerApiAttachmentVideoMetadata = (
  metadata?: MessengerApiAttachmentMetadata,
): metadata is MessengerApiAttachmentVideoMetadata => metadata?.type === 'video'
